import type { FC } from 'react'

import { formatTimestamp } from '@modules/utils/dateUtils'

/**
 * リソース (AI Color プロジェクト / Area Estimation プロジェクト等) の
 * 編集可能タイトル直下に出す creation-log 行。
 *
 * Figma SSOT: 13607-16118 (Area Estimation 詳細ヘッダー) ※AI Color も同形式
 *   - fontSize: 12 (text-xs)
 *   - color: #71717A = `text-muted-foreground`
 *   - layout: row, gap 16px, ラベルなし
 *
 * authorName / updatedAt がどちらも未指定なら何も描画しない。
 */
interface Props {
  /** 最終編集者名。空文字 / undefined なら省略 */
  authorName?: string
  /** 最終更新日時。undefined なら省略 */
  updatedAt?: Date
}

export const ResourceMetaLine: FC<Props> = ({ authorName, updatedAt }) => {
  if (!authorName && !updatedAt) {
    return null
  }
  return (
    <div className="flex flex-wrap gap-x-4 gap-y-2 text-xs text-muted-foreground">
      {authorName ? <span>{authorName}</span> : null}
      {updatedAt ? <span>{formatTimestamp(updatedAt)}</span> : null}
    </div>
  )
}
